export default {
    listagem: {
        titulo_pagina: 'Lista de Credenciais',
        novo: 'Criar nova Credencial',
        table: {
            empty: 'Nenhuma Credencial encontrada',
            nome: 'Nome',
            empresa: 'Empresa',
            usuario: 'Usuário',
            homologacao: 'Homologação',
            classe: 'Classe',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar nova Credencial',
            editar: 'Editar Credencial'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome da Credencial'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa a qual pertence a credencial'
            },
            usuario: {
                label: 'Nome de Usuário',
                description: 'Nome que será usado na credencial'
            },
            senha: {
                label: 'Senha',
                description: 'Senha que será usado na credencial'
            },
            entidade: {
                label: 'Entidade',
                description: 'Entidade que será usada na credencial'
            },
            homologacao: {
                label: 'Homologação',
                description: 'Status ativo ou inativo da credencial em Homologação'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Credencial'
            },
            botao_salvar : 'Salvar Credencial'
        },
        create: {
            success: 'Credencial criado com Sucesso!',
            error: 'Error ao criar Credencial!'
        },
        update: {
            success: 'Credencial editado com Sucesso!',
            error: 'Error ao editar Credencial!'
        }
    }
}
